
import { Component, Vue } from "vue-property-decorator";
import SideNav from "@/components/SideNav.vue";
import TopNav from "@/components/TopNav.vue";
import { MenuItem } from "./types";

@Component({
  components: {
    SideNav,
    TopNav,
  },
})
export default class PortfolioPage extends Vue {
  name = "Chloe Zhang";
  sub_name = "portfolio";
  position = "designer";

  menuList: MenuItem[] = [
    {
      titleName: "",
      items: [
        { name: "About", target: "/about" },
      ],
    },
    {
      titleName: "Visual Art",
      items: [
        { name: "Drawings", target: "/visual_art/drawings" },
        { name: "Flamingo Series", target: "/visual_art/flamingo" },
        { name: "Design", target: "/visual_art/design" },
        { name: "Sewing and Yarn", target: "/visual_art/sewing_yarn" },
      ],
    },
    {
      titleName: "Music",
      items: [
        { name: "High school orchestra-FPO", target: "/music_event/fpo_band" },
        { name: "SSPO and URFO", target: "/music_event/urfo_school_band" },
        { name: "Video", target: "/music_event/video" },        
        { name: "Composition and Transcription", target: "/music_event/composition" },
      ],
    },
    {
      titleName: "NEURONETWORK",
      items: [
        { name: "Associations and Forums", target: "/club_forum_event/forum" },        
        // { name: "Tutor Material", target: "/club_forum_event/tutor_material" },
        { name: "Club Activities", target: "/club_forum_event/club_activities" },
        { name: "Tutor Material Download", target: "/club_forum_event/downloads" },
      ],
    },
    // {
    //   titleName: "Other",
    //   items: [
    //     { name: "Friends", target: "/other/friends" },
    //     { name: "Cats Station", target: "/other/cats_station" },
    //   ],
    // },
  ];

  mounted() {
  }
}
